export const COMPANY_PORTAL_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3001"
    : process.env.REACT_APP_PUBLIC_COMPANY_URL;

export const OTP_TIME = 45;

// for subscription plan
export const SUBSCRIPTION_PLAN_TYPES = {
  CREATE: "Create Subscription Plan",
  EDIT: "Edit Subscription Plan",
  // VIEW: "",
};

export const CRUD_PLAN_TYPES = {
  CREATE: "create",
  VIEW: "view",
  EDIT: "edit",
};

export const KEYSET_GROUP_NAME = "KeySet Group";
